import { withInstall } from '@lit-element/utils'

import ConfigProvider from './src/config-provider'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtConfigProvider: SFCWithInstall<typeof ConfigProvider> =
  withInstall(ConfigProvider)
export default LtConfigProvider

export * from './src/config-provider'
export * from './src/config-provider-props'
export * from './src/constants'
export * from './src/hooks/use-global-config'
